import { createModuleStore } from '../utils'
const createInitialFilterState = () => {
  return {
    selectedReadZones: [],
    selectedCategories: [],
    selectedSites: [],
    selectedItems: [],
    endTimestamp: null,
    startTimestamp: null,
    period: 'PAST_3_MONTHS',
  }
}
export const useMovementHistoryStore = createModuleStore(
  'movemement-histories',
  {
    type: 'Movement History',
    pageHeading: 'Movement History',
    noHistory: true,
    sortingOn: 'toolbar',
    statusesFilterName: 'statuses',
    uploadOptionsCsv: '',
    noAdd: true,
    noEdit: true,
    noDeactivate: true,
    noActivate: true,
    noCopy: true,
    uri: '/rf-detected-presence',
    serviceUri: '/rf-detected-presence',
    listingModuleName: 'Reports',
    listingActivityName: 'View Movement History',
    remarkModalData: null,
    showRemarkModal: false,
    allFields: [
      {
        key: 'itemName',
        title: 'NAME',
        visible: true,
        sortable: false,
        disabled: false,
      },
      {
        key: 'itemTag',
        title: 'RFID',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'legitimate',
        title: 'LEGITIMATE',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'entryTimestamp',
        title: 'ENTRY TIME',
        visible: true,
        sortable: false,
        disabled: false,
        type: 'datetime',
      },
      {
        key: 'exitTimestamp',
        title: 'EXIT TIME',
        visible: true,
        sortable: false,
        disabled: false,
        type: 'datetime',
      },
      {
        key: 'expired',
        title: 'EXPIRED',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'floorName',
        title: 'FLOOR',
        visible: true,
        sortable: false,
        disabled: false,
      },
      {
        key: 'floorUuid',
        title: 'FLOOR UUID',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'itemCategoryName',
        title: 'CATEGORY',
        visible: true,
        sortable: false,
        disabled: false,
      },
      {
        key: 'itemCategoryUuid',
        title: 'CATEGORY UUID',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'readzoneName',
        title: 'LOCATION',
        visible: true,
        sortable: false,
        disabled: false,
      },
      {
        key: 'readzoneType',
        title: 'LOCATION TYPE',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'readzoneUuid',
        title: 'LOCATION UUID',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'siteName',
        title: 'SITE',
        visible: true,
        sortable: false,
        disabled: false,
      },
      {
        key: 'siteUuid',
        title: 'SITE UUID',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'externalId',
        title: 'UUID',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'createdBy',
        title: 'CREATED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'createdTimestamp',
        title: 'CREATED TIME',
        type: 'datetime',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedBy',
        title: 'LAST MODIFIED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedTimestamp',
        title: 'LAST MODIFIED TIME',
        type: 'datetime',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'status',
        title: 'STATUS',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'actions',
        title: 'ACTIONS',
        visible: true,
        disabled: true,
        sortable: false,
      },
    ],
  },
  {
    supportedPageFilters: {
      periodApplicable: 'true',
      selectedSites: {
        type: 'sites',
        multiple: true,
        placeholder: 'Pick one or more sites to filter',
        optionsLabel: 'name',
        submitValueKey: 'externalId',
      },
      selectedReadZones: {
        type: 'readzones',
        multiple: true,
        placeholder: 'Pick one or more readzones to filter',
        optionsLabel: 'name',
        submitValueKey: 'externalId',
      },
      selectedCategories: {
        type: 'categories',
        multiple: true,
        placeholder: 'Pick one or more categories to filter',
        optionsLabel: 'name',
        submitValueKey: 'externalId',
        serviceUri: '/categories/selfAndBelow/Assets',
      },
      selectedItems: {
        type: 'trackedItems',
        multiple: true,
        placeholder: 'Pick one or more items to filter',
        optionsLabel: 'name',
        submitValueKey: 'externalId',
        serviceUri: '/tracked-items',
      },
    },
    filters: createInitialFilterState(),
  },
  {
    resetPageFilters() {
      const store = useMovementHistoryStore()
      store.filters = createInitialFilterState()
      store.supportedPageFilters.periodApplicable = 'true'
      store.resetBaseFilters()
    },
  },
  {}
)
